import React from 'react';
import './Loader.scss';

// Full-screen loading overlay: a centered teal spinner ring on a light scrim
// that covers the whole viewport (above the sidebar). Pass fullScreen={false}
// for an inline, in-flow spinner inside a panel/section instead.
const Loader = ({ text = 'Loading...', fullScreen = true }) => {
  return (
    <div
      className={`un-loader ${fullScreen ? 'un-loader--fullscreen' : 'un-loader--inline'}`}
      role="status"
      aria-live="polite"
    >
      <div className="un-loader__box">
        <div className="un-loader__ring" aria-hidden="true"></div>
        {text ? <p className="un-loader__text">{text}</p> : null}
      </div>
    </div>
  );
};

export default Loader;
